import axiosInstance from './api'

export const couponsApi = {
  validateCoupon: async (code, purchaseType, originalAmount, teamId = null) => {
    const response = await axiosInstance.post('/coupons/validate', {
      code: code.trim().toUpperCase(),
      purchaseType,
      originalAmount,
      teamId
    })
    return response.data
  },

  getAllCoupons: async (params = {}) => {
    const response = await axiosInstance.get('/coupons', {
      params
    })
    return response.data
  },

  createCoupon: async (couponData) => {
    const data = {
      ...couponData,
      code: couponData.code.trim().toUpperCase()
    }
    const response = await axiosInstance.post('/coupons', data)
    return response.data
  },

  updateCoupon: async (id, updateData) => {
    const data = {
      ...updateData,
      ...(updateData.code && { code: updateData.code.trim().toUpperCase() })
    }
    const response = await axiosInstance.put(`/coupons/${id}`, data)
    return response.data
  },

  deleteCoupon: async (id) => {
    const response = await axiosInstance.delete(`/coupons/${id}`)
    return response.data
  },

  getCouponUsages: async (id, page = 1, limit = 20) => {
    const response = await axiosInstance.get(`/coupons/${id}/usages`, {
      params: { page, limit }
    })
    return response.data
  }
} 